import React from 'react';
import { useInjury } from '../../../contexts/InjuryContext';

/**
 * Mobile-native injury / IL badge.
 *
 * Bible §14 mobile/desktop separation: the desktop `components/InjuryBadge.js`
 * is NEVER imported on mobile. This is a mobile-native component that consumes
 * the SAME shared data source — `useInjury(mlbId)` from the app-wide
 * InjuryContext (a global mlbId→status lookup, the shared backend/data layer) —
 * and renders it with mobile inline styling that matches the mobile roster pills
 * (7px, tokenised colors). Full status parity with desktop: DTD / 15-IL / 60-IL / IL.
 */
const MobileInjuryBadge = ({ mlbId, style }) => {
  const injury = useInjury(mlbId);
  if (!injury) return null;

  const status = injury.status || '';
  let label, bg, fg;
  if (status.includes('Day-To-Day')) {
    label = 'DTD'; bg = 'rgba(234,179,8,0.20)'; fg = '#facc15';       // yellow
  } else if (status.includes('60-Day') || status === 'Out') {
    label = '60-IL'; bg = 'rgba(239,68,68,0.20)'; fg = '#f87171';     // red
  } else if (status.includes('15-Day')) {
    label = '15-IL'; bg = 'rgba(249,115,22,0.20)'; fg = '#fb923c';    // orange
  } else {
    label = 'IL'; bg = 'rgba(249,115,22,0.20)'; fg = '#fb923c';       // orange
  }

  const tooltip = injury.description
    ? `${injury.description}${injury.return_date ? ` · ETA: ${injury.return_date}` : ''}`
    : status;

  return (
    <span
      title={tooltip}
      style={{
        display: 'inline-flex', alignItems: 'center',
        fontSize: '7px', fontWeight: 700, padding: '1px 3px', marginLeft: '4px',
        borderRadius: '3px', lineHeight: 1.2, flexShrink: 0,
        background: bg, color: fg, border: `1px solid ${fg}55`,
        ...style,
      }}
    >
      {label}
    </span>
  );
};

export default MobileInjuryBadge;
